define((require) => {
    "use strict";

    var AnimationPropertiesView       = require("ui/experience/widgets/animations/AnimationPropertiesView"),
        SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView"),
        template                      = require("ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetPropertiesView.tpl"),
        AbstractWidgetPropertiesView  = require("ui/experience/widgets/AbstractWidgetPropertiesView");

    var EXPAND_PROPERTY = "navigatorWidgetExpanded";

    /**
     * @class SceneNavigatorWidgetPropertiesView
     * @constructor
     *
     * @cfg {SceneNavigatorWidgetModel}
     */
    return AbstractWidgetPropertiesView.extend({

        expandProperty: EXPAND_PROPERTY,

        className: "scene-navigator-widget-properties-view",

        template: template,

        ui: {
            container: ".navigator-widget-properties",
            legend: "[data-target=\".navigator-widget-properties\"]",
            optionsContainer: ".options"
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            animationProperties: ".animation-properties"
        },

        bindings: {
            ".direction-select": "direction"
        },

        events: {
            "click .options a": function(event) {
                event.preventDefault();

                // Parse the selected theme
                var theme = event.currentTarget.getAttribute("data-theme");

                // Update the model
                this.model.set("theme", theme);
            }
        },

        modelEvents: {
            "change:theme": "_updateToCurrentTheme"
        },

        /**
         * Updates the UI by reflecting the current selected theme.
         */
        _updateToCurrentTheme: function() {
            // Reset 'selected' state
            this.ui.optionsContainer.find("a").removeClass("selected");
            this.ui.optionsContainer.find("a ul :first-child").removeClass("active");

            var selectedTarget = this.ui.optionsContainer.find("[data-theme='" + this.model.get("theme") + "']");
            selectedTarget.addClass("selected");
            selectedTarget.find("ul :first-child").addClass("active");
        },

        onRender: function() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                hideSizeControls: true,
                hideRotation: true,
                widgetView: this.options.widgetView
            }));
            this.animationProperties.show(new AnimationPropertiesView({model: this.model, widgetView: this.options.widgetView}));

            this._updateToCurrentTheme();
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetPropertiesView.js